<section class="contact-page">
  <div class="contact-container">
    <form class="contact-form" [formGroup]="contactForm" (ngSubmit)="submit()">
      <div class="form-row">
        <div class="form-group">
          <label>{{ 'CONTACT.FIRST_NAME' | translate }}</label>
          <input type="text" formControlName="firstName" [attr.aria-label]="'CONTACT.FIRST_NAME' | translate" />

          <small class="error" *ngIf="contactForm.get('firstName')?.touched && contactForm.get('firstName')?.invalid">
            <span *ngIf="contactForm.get('firstName')?.errors?.['required']">
              ⚠️ {{ 'CONTACT.ERR_FIRST_NAME' | translate }}
            </span>
          </small>
        </div>

        <div class="form-group">
          <label>{{ 'CONTACT.LAST_NAME' | translate }}</label>
          <input type="text" formControlName="lastName" [attr.aria-label]="'CONTACT.LAST_NAME' | translate" />

          <small class="error" *ngIf="contactForm.get('lastName')?.touched && contactForm.get('lastName')?.invalid">
            <span *ngIf="contactForm.get('lastName')?.errors?.['required']">
              ⚠️ {{ 'CONTACT.ERR_LAST_NAME' | translate }}
            </span>
          </small>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>{{ 'CONTACT.EMAIL' | translate }}</label>
          <input type="email" formControlName="email" [attr.aria-label]="'CONTACT.EMAIL' | translate" />

          <small class="error" *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.invalid">
            <span *ngIf="contactForm.get('email')?.errors?.['required']">
              ⚠️ {{ 'CONTACT.ERR_EMAIL_REQ' | translate }}
            </span>
            <span *ngIf="contactForm.get('email')?.errors?.['email']">
              ⚠️ {{ 'CONTACT.ERR_EMAIL_INVALID' | translate }}
            </span>
          </small>
        </div>

        <div class="form-group">
          <label>{{ 'CONTACT.PHONE' | translate }}</label>
          <input type="text" formControlName="phone" [attr.aria-label]="'CONTACT.PHONE' | translate" />

          <small class="error" *ngIf="contactForm.get('phone')?.touched && contactForm.get('phone')?.invalid">
            <span *ngIf="contactForm.get('phone')?.errors?.['pattern'] || contactForm.get('phone')?.errors?.['maxlength']">
              ⚠️ {{ 'CONTACT.ERR_PHONE_FORMAT' | translate }}
            </span>
             <span *ngIf="contactForm.get('phone')?.errors?.['required']">
              ⚠️ {{ 'CONTACT.ERR_PHONE_REQ' | translate }}
            </span>
          </small>
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'CONTACT.MESSAGE' | translate }}</label>
        <textarea rows="6" [placeholder]="'CONTACT.MESSAGE_PLACEHOLDER' | translate" formControlName="message"></textarea>
          <small class="error" *ngIf="contactForm.get('message')?.touched && contactForm.get('message')?.invalid">
            <span *ngIf="contactForm.get('message')?.errors?.['required']">
              ⚠️ {{ 'CONTACT.ERR_MESSAGE_REQ' | translate }}
            </span>
          </small>
      </div>

      <button type="submit" class="submit-btn" [disabled]="contactForm.invalid">
        {{ 'CONTACT.SUBMIT_BTN' | translate }}
      </button>
    </form>

    <aside class="contact-info">
      <h2>{{ 'CONTACT.INFO_TITLE' | translate }}</h2>
      <p class="info-desc">
        {{ 'CONTACT.INFO_DESC' | translate }}
      </p>

      <div class="info-item">
        <span class="icon">📞</span>
        <span>+84 901 110 102</span>
      </div>

      <div class="info-item">
        <span class="icon">✉️</span>
        <span>11N02&#64;gmail.com</span>
      </div>

      <div class="info-item">
        <span class="icon">📍</span>
        <span>{{ 'FOOTER.ADDRESS_DETAIL' | translate }}</span>
      </div>
      <div class="contact-map">
        <iframe [src]="mapUrl" width="100%" height="260" style="border: 0" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade" [title]="'CONTACT.MAP_TITLE' | translate"></iframe>
      </div>
    </aside>
  </div>
</section>